/**
 * <h3>动画库</h3> 
 * <h5>动画控制器</h5>
   * {{#crossLink "bui.animate"}}{{/crossLink}}: 常用的transform动画及属性动画 <br>
 * <h5>动画切换器</h5>
   * {{#crossLink "bui.toggle"}}{{/crossLink}}: animate.css的常用动画,切换显示 <br>
 * 
 * @module Animate
 */
;(function (ui,$) {
  /**
   * 常用的动画,有transform动画,链式动画,属性动画
   * 
   * <h5>动画配置修改</h5>
   * {{#crossLink "bui.animate/option"}}{{/crossLink}}: 设置修改参数 <br>
   * {{#crossLink "bui.animate/widget"}}{{/crossLink}}: 获取依赖的控件 <br>
   * {{#crossLink "bui.animate/origin"}}{{/crossLink}}: 修改动画原点 <br>
   * {{#crossLink "bui.animate/transition"}}{{/crossLink}}: 修改动画时间 <br>
   * {{#crossLink "bui.animate/open3D"}}{{/crossLink}}: 开启3D加速对rotate有效果 <br>
   * <h5>综合动画</h5>
   * {{#crossLink "bui.animate/transform"}}{{/crossLink}}: 综合动画,需要熟悉transform属性 <br>
   * <h5>位移动画</h5>
   * {{#crossLink "bui.animate/left"}}{{/crossLink}}: 左移动画 <br>
   * {{#crossLink "bui.animate/right"}}{{/crossLink}}: 右移动画 <br>
   * {{#crossLink "bui.animate/up"}}{{/crossLink}}: 上移动画 <br>
   * {{#crossLink "bui.animate/down"}}{{/crossLink}}: 下移动画 <br>
   * <h5>缩放动画</h5>
   * {{#crossLink "bui.animate/scale"}}{{/crossLink}}: 缩放动画 <br>
   * {{#crossLink "bui.animate/scaleX"}}{{/crossLink}}: 水平缩放动画 <br>
   * {{#crossLink "bui.animate/scaleY"}}{{/crossLink}}: 垂直缩放动画 <br>
   * <h5>旋转动画</h5>
   * {{#crossLink "bui.animate/rotate"}}{{/crossLink}}: 左移动画 <br>
   * {{#crossLink "bui.animate/rotateX"}}{{/crossLink}}: 右移动画 <br>
   * {{#crossLink "bui.animate/rotateY"}}{{/crossLink}}: 左移动画 <br>
   * <h5>扭曲动画</h5>
   * {{#crossLink "bui.animate/skew"}}{{/crossLink}}: 扭曲动画 <br>
   * {{#crossLink "bui.animate/skewX"}}{{/crossLink}}: 水平扭曲动画 <br>
   * {{#crossLink "bui.animate/skewY"}}{{/crossLink}}: 垂直扭曲动画 <br>
   * <h5>属性动画</h5>
   * {{#crossLink "bui.animate/property"}}{{/crossLink}}: 属性动画 性能差,尽量少用<br>
   * 
   * @namespace  bui
   * @class  animate
   * @constructor 
   * @example
   * 
       //初始化page对象
       var uiAnimate = bui.animate("#page");
   
       //链式动画
       uiAnimate.left(100).down(100).start();
     
       //累计动画,左移动画以后下移各自100px,
       uiAnimate.left(100).start(function({
       
         uiAnimate.down(100).start();
       }));
   
       //综合动画, 只执行一次,下次执行会从头开始
       uiAnimate.transform("translateX(-100px)") ==  uiAnimate.left(100).stop();
   * 
   */
    ui.animate = function (option){

        //默认配置
        var config = {
            id: "",
            zoom: true,
            open3D: false,
            animates: []
        };

        // zepto库 跟 jquery 对 Object.prototype.toString.call(option) === "[object Array]" 解析不一样
        if( typeof option === "object" && option.id ){

            option = option || {};
        }else{
            var opt = option || "";

            option = {};
            option.id = opt;
        }

        //方法
        var module = {
            origin: origin,          //修改动画远点
            transition:transition,    //修改动画的执行时间
            property: property,      //属性动画
            open3D: open3D,        //3D动画,还会开启GPU加速, 对rotateXrotateY有效
            transform: transform,    //综合动画,需要熟悉 transform 动画
            start: start,            //动画串接器,会累积之前的动画位置
            stop: stop,              //动画串接器,做完动画会清除之前的动画
            left: left,              //左移动画
            right: right,            //右移动画
            up: up,                  //上移动画
            down: down,              //下移动画
            scale: scale,            //缩放动画
            scaleX: scaleX,          //水平缩放
            scaleY: scaleY,          //纵向缩放
            rotate: rotate,          //旋转动画
            rotateX: rotateX,        //开启3D加速才会有效果
            rotateY: rotateY,        //开启3D加速才会有效果
            skew: skew,              //扭曲动画
            skewX: skewX,            //水平扭曲
            skewY: skewY,            //纵向扭曲
            reverse: reverse,         //返回原位,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, option );
        
        var $id,
            turnOn3D, //开启3D硬件加速
            rem,
            animates ,
            historys = [];
        var trans = "all 300ms ease-out";

        //初始化动画对象
        init(param);
       
        function init (option) {

          if( option.id ){
                $id = ui.obj(option.id);
          }else{

              ui.hint("animate id不能为空");
              return;
          }

          $id.css({
            '-webkit-transition':trans,
            'transition':trans
          })

          turnOn3D = option.open3D; //开启3D硬件加速
          rem = option.zoom;

          animates = option.animates;
          param = module.config = option;

          return this;
        }

        /**
         *  左移动画
         *  @method left
         *  @param {number} num 正数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //链式动画
             uiAnimate.left(100).start();
         */
        function left (num) {

          var num = num;;
          var value = Math.abs( parseFloat(num) ) ;

          if( typeof num === "string" && num.indexOf("%") > -1 ){
            num = "-" + num;
          }else {
            num = rem ? -(value/100) + 'rem':-(value)+"px";
          }
          var action = "translateX("+num+")";

          //保存动画
          animates.push(action);

          return this;

        }
        /**
         *  右移动画
         *  @method right
         *  @param {number} num 正数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //链式动画
             uiAnimate.right(100).start();
         */
        function right (num) {

          var num = num;;
          var value = Math.abs( parseFloat(num) ) ;

          if( typeof num === "string" && num.indexOf("%") > -1 ){
            num = num;
          }else {
            num = rem ? (value/100) + 'rem': (value)+"px";

          }
          var action = "translateX("+num+")";
          
          //保存动画
          animates.push(action);

          return this;

        }
        /**
         *  上移动画
         *  @method up
         *  @param {number} num 正数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //链式动画
             uiAnimate.up(100).start();
         */
        function up (num) {

          var num = num;
          var value = Math.abs( parseFloat(num) ) ;


          if( typeof num === "string" && num.indexOf("%") > -1 ){
            num = "-" + num;
          }else {
            num = rem ? -(value/100) + 'rem':-(value)+"px";

          }
          var action = "translateY("+num+")";


          
          //保存动画
          animates.push(action);

          return this;

        }
        /**
         *  下移动画
         *  @method down
         *  @param {number} num 正数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //链式动画
             uiAnimate.down(100).start();
         */
        function down (num) {

          var num = num;
          var value = Math.abs( parseFloat(num) ) ;


          if( typeof num === "string" && num.indexOf("%") > -1 ){
            num = num;
          }else {
            num = rem ? (value/100) + 'rem': (value)+"px";
          }
          var action = "translateY("+num+")";

          
          //保存动画
          animates.push(action);

          return this;
        }
        
        /**
         *  缩放动画
         *  @method scale
         *  @param {string} num  示例: "2" | "2,2"
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //链式动画
             uiAnimate.scale("2,2").start();
         */
        function scale (num) {
          var str = String(num);
          var num = str.indexOf(",") > -1 ? str: num+",1";
          var action = "scale("+num+")";

          //保存动画
          animates.push(action);
          return this;
        }
        /**
         *  水平缩放动画
         *  @method scaleX
         *  @param {number} num  示例: 2
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //链式动画
             uiAnimate.scaleX(2).start();
         */
        function scaleX (num) {

          var num = String(num);
          var action = "scaleX("+num+")";

          
          //保存动画
          animates.push(action);

          return this;
        }
        /**
         *  垂直缩放动画
         *  @method scaleY
         *  @param {number} num  示例: 2
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //链式动画
             uiAnimate.scaleY(2).start();
         */
        function scaleY (num) {

          var num = String(num);
          var action = "scaleY("+num+")";

          
          //保存动画
          animates.push(action);

          return this;
        }
        /**
         *  旋转动画
         *  @method rotate
         *  @param {number} num  度数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //链式动画
             uiAnimate.rotate(45).start();
         */
        function rotate (num) {
          var str = String(num);
          var num = str.indexOf("deg") > -1 ? str: str + "deg";

          var action = "rotate("+num+")";

          //保存动画
          animates.push(action);

          return this;

        }
        /**
         *  水平旋转动画
         *  @method rotateX
         *  @param {number} num  度数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //需要开启3d动画才会有效
             uiAnimate.open3D().rotateX(45).start();
         */
        function rotateX (num) {
          var str = String(num);
          var num = str.indexOf("deg") > -1 ? str: str + "deg";
          var action = "rotateX("+num+")";

          
          //保存动画
          animates.push(action);

          return this;
        }
        /**
         *  垂直伸展动画
         *  @method rotateY
         *  @param {number} num  度数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //需要开启3d动画才会有效
             uiAnimate.open3D().rotateY(45).start();
         */
        function rotateY (num) {
          var str = String(num);
          var num = str.indexOf("deg") > -1 ? str: str + "deg";
          var action = "rotateY("+num+")";

          
          //保存动画
          animates.push(action);

          return this;
        }
        /**
         *  扭曲动画
         *  @method skew
         *  @param {string} num  度数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //执行动画
             uiAnimate.skew("10,10").start();
         */
        function skew (num) {
          var str = String(num);
          var num;
          var values = [];
          //分别判断是否带deg
          if (str.indexOf(",") > -1 ){
            values = str.split(",");
            num = "";
            $(values).each(function (i,item) {

              if( i < 2){
                num += item.indexOf('deg') > -1 ? ","+item: ","+item + "deg";
              }
            })

            num = num.substr(1);

          }else{
            num = str.indexOf("deg") > -1 ? str: str + "deg,0";
          }

          var action = "skew("+num+")";

          animates.push(action);

          return this;

        }

        /**
         *  横向扭曲
         *  @method skewX
         *  @param {number} num  度数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //执行动画
             uiAnimate.skewX(20).start();
         */
        function skewX (num) {
          var str = String(num);
          var num = str.indexOf("deg") > -1 ? str: str + "deg";
          var action = "skewX("+num+")";

          animates.push(action);

          return this;
        }
        /**
         *  纵向扭曲
         *  @method skewY
         *  @param {number} num  度数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //执行动画
             uiAnimate.skewY(20).start();
         */
        function skewY (num) {
          var str = String(num);
          var num = str.indexOf("deg") > -1 ? str: str + "deg";
          var action = "skewY("+num+")";
          
          //保存动画
          animates.push(action);

          return this;
        }

        /**
         *  在做动画前更改原点,几种写法 left,top || 25%,75% || right 对旋转放大扭曲有效
         *  @method origin
         *  @param {string} num  度数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //执行动画
             uiAnimate.origin("25%,75%").rotate(45).start();
         */
        function origin (num) {

          var str = String(num);
          $id.css({
              '-webkit-transform-origin':str,
              'transform-origin':str
          });

          return this;

        }

        /**
         *  动画的执行时间
         *  @method transition
         *  @param {number} time  动画的执行时间 单位:ms
         *  @param {string} [easing]  动画的效果 ease-in | ease-out | ease
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //执行动画
             uiAnimate.transition(500).left(200).start();
         */
        function transition (time,easing) {

          var ease = easing || "ease-out";
          // 缓冲时间
          if(typeof time === "number"){
            trans = "all "+time+"ms "+ease;
          }else{
            if(time == false || time == "none" ){
              trans = "none";
            }else if( time == true ){
              trans = "all 300ms "+ease;
            }else{
              trans = time || "all 300ms "+ease;
            }
          }
          $id.css({
              '-webkit-transition':trans,
              'transition':trans
          });

          return this;

        }

        /**
         *  清除动画
         *  @method stop
         *  @param {function} [callback]  动画执行完触发
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //执行动画
             uiAnimate.stop().left(200).start();
         */
        function stop (callback) {

          var action = turnOn3D ? animates.join("")+ "translateZ(0)": animates.join(""),

              self = this;

          $id.css({
              '-webkit-transform':action,
              'transform':action
          });


          //动画结束以后回调
          if( trans !="none" ){
              $id.one('webkitTransitionEnd',function(){

                 callback && callback.call(this,module);

              });
          }

          //清除动画
          animates = [];

          return this;

        }
        
        /**
         *  动画链式的触发
         *  @method start
         *  @param {function} [callback]  动画执行完触发
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //执行动画
             uiAnimate.left(200).down(200).start();
         */
        function start(callback) {

          var action = turnOn3D ? animates.join("")+ "translateZ(0)": animates.join(""),

              self = this;

          $id.css({
              '-webkit-transform':action,
              'transform':action
          });


          //动画结束以后回调
          if( trans !="none" ){
              $id.one('webkitTransitionEnd',function(){

                 callback && callback.call(this,module);

              });
          }

          return this;
        }

        /**
         *  transform独立动画,无需start,但要配合transition使用
         *  @method transform
         *  @param {string} action  要执行的动画
         *  @param {function} [callback]  动画执行完触发
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //执行动画
             uiAnimate.transition(500).transform("translateX(-200px)";
         */
        function transform (action,callback) {

          $id.css({
              '-webkit-transform':action,
              'transform':action
          });

          //动画结束以后回调
          if( callback && transition !="none" ){
              $id.one('webkitTransitionEnd',function(){
                
                 callback.call(this,module);
              });
          }

          return this;

        }

        /**
         *  开启3D透视,景深,对旋转动画有效,同时会开启GPU硬件加速
         *  @method open3D
         *  @param {number} num  度数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //需要开启3d动画才会有效
             uiAnimate.open3D().rotateY(45).start();
         */
        function open3D (num) {
          num = parseFloat(num) || 100;

          //开启3D硬件加速
          turnOn3D = true; 
          $id.parent().css({
            "perspective": num + 'px'
          })

          return this;
        }

        /**
         *  返回原来位置,只对transform有效
         *  @method reverse
         *  @param {number} num  度数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //清除动画的位置
             uiAnimate.reverse();
         */
        function reverse (argument) {

          $id.css({
              '-webkit-transform':"",
              'transform':""
          });

          animates.push("");
          return this;

        }

        /**
         *  属性动画,无需start 相对transform会比较耗性能, 配合 transition使用
         *  @method property
         *  @param {number} num  度数
         *  @chainable
         *  @example 
            //初始化page对象
             var uiAnimate = bui.animate("#page");
         
             //清除动画的位置
             uiAnimate.transition(500).property("width","500px");
         */
        function property (key,value) {

          var obj = {};

          if( typeof key === "object"){
            obj = key;
            value = "";
          }else if( typeof key === "string" ){
            obj[key] = value || "";
          }
              
          $id.css(obj);

          return this;

        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            //获取依赖控件 
            var uiAnimateWidget = uiAnimate.widget();
            
                
         */
        function widget(name) {
            var control = {};
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiAnimate.option();

            //获取某个参数
            var id = uiAnimate.option( "id" );

            //修改一个参数
            uiAnimate.option( "open3D",false );

            //修改多个参数
            uiAnimate.option( {"open3D":false} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }
        return module;

    };

    return ui;

})( bui || {}, libs );
